// extracted by mini-css-extract-plugin
export default {"mypage_subsc_complete":"complete_mypage_subsc_complete__xJa6V","mypage_subsc_back_button":"complete_mypage_subsc_back_button__2NS2K"};